// ABOUTME: Forgot password form content for requesting a password reset email.
// ABOUTME: Renders inside AuthLayout which provides the shared shell (logo, controls, OnTheRight).
import { Box, InputBase, Typography, useTheme } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import * as yup from "yup";
import Shbutton from "../../components/theme/buttons/Shbutton";

import MailOutlineIcon from '@mui/icons-material/MailOutline';

import cx from 'classnames';
import { useTranslation } from "react-i18next";
import { useRequestPasswordResetMutation } from "../../newapi/user/passwordresetSlice";
import { tokens } from "../../theme";

// import { login } from "../../api/global/user";
// import { useAuth } from "../../authentication/AuthState";
const initialValues = {
    email: "",
}

const userSchema = yup.object().shape({
    email: yup
    .string()
    .email("Ongeldig e-mailadres")
    .required("required"),
});

const Forgotpassword = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const [errorMessage, setErrorMessage] = useState("");

    const { isOnline, brand, brandSlug } = useOutletContext();

    const [RequestPasswordReset, { isSuccess, isLoading, isUninitialized, isError, error }] = useRequestPasswordResetMutation();

    const handleFormSubmit = async (values) => {
        setErrorMessage("");

        let resetVals = {email: values.email};

        try {
            await RequestPasswordReset(resetVals);
        } catch (error) {
            console.error('Reset request failed:', error.message);
        }

    }

    useEffect(() => {
        if(isError) {
            setErrorMessage("Reset request failed");
            return;
        }



    },[isSuccess, isError]);

    return (
        <Box
            sx={{
                padding: "32px",
                borderRadius: "24px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                paddingTop:"40px",
                "@media screen and (max-width: 47.9375em)": {
                    p:0,
                    px:3,
                }
            }}
        >

            <Typography variant="h1" fontWeight="1000" fontFamily="Roboto, sans-serif"
                sx={{
                    color:colors.txt['primary'],
                    textOverflow:"ellipsis",
                    whiteSpace:"nowrap",
                    overflow:"hidden",
                    fontSize:"32px",
                    "@media screen and (max-width: 47.9375em)" : {
                        fontSize:21
                    }
                }}
            >
                {isSuccess ?
                    t("forgot_password_request_success")
                :
                    t("forgot_password")
                }
            </Typography>
            <Typography variant="p" fontWeight="400" fontFamily="Roboto, sans-serif"
                sx={{
                    color:colors.txt['secondary'],
                    fontSize:"17px",
                    textAlign:'center',
                    marginBottom:4,
                    "@media screen and (max-width: 47.9375em)" : {
                        fontSize:14,
                        marginBottom:3,
                    }
                }}
            >
                {isSuccess ?
                    t("forgot_password_request_success_description")
                :
                    t("forgot_password_description")
                }
            </Typography>

            <Box
                sx={{
                    "@media screen and (max-width: 47.9375em)" : {
                        width:1,
                    }
                }}
            >
                {!isSuccess ?
                <Formik
                    key="login-mode"
                    enableReinitialize
                    onSubmit={handleFormSubmit}
                    initialValues={initialValues}
                    validationSchema={userSchema}>
                    {({values, errors, touched, handleBlur, handleChange, handleSubmit}) => (
                        <form className="login-form" onSubmit={handleSubmit}>
                            <Box
                                className={cx({
                                    'error': !!touched.email && !!errors.email
                                })}

                                display="flex"
                                sx={{
                                    width:"450px",
                                    borderRadius:6,
                                    display:"flex",
                                    alignItems:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                    border:theme.palette.mode === "dark" ? null : "1px solid rgba(255,255,255,.15)",
                                    height:48,
                                    pl:2,
                                    "&.error": {
                                        background:colors.red[100],
                                        border: `1px solid ${colors.red[400]}`,
                                        color: colors.red[400]
                                    },
                                    "input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active" : {
                                        backgroundClip:colors.txt['primary'],
                                        "webkit-text-fill-color":colors.txt['primary'],
                                        transition: "background-color 5000s ease-in-out 0s",
                                        boxShadow:`inset 0 0 20px 20px ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                                        WebkitTextFillColor: colors.txt['primary'],
                                        fontSize:16
                                    },
                                    "@media screen and (max-width: 64em)" : {
                                        height:40,
                                        borderRadius:5,
                                        px:1,
                                    },
                                    "@media screen and (max-width: 47.9375em)" : {
                                        width:1,
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        height:32,
                                        width:32,
                                        textAlign:"center",
                                        color: colors.txt['secondary'],
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                    }}
                                >
                                    <MailOutlineIcon
                                        // color={!!touched.email && !!errors.email ? "red" : "primaryGrey"}

                                    />

                                </Box>
                                <InputBase
                                name={"email"}
                                    autoFocus
                                    type={"email"}
                                    sx={{
                                        pl:1.5,
                                        flex:1,
                                        color:colors.txt['primary'],
                                        fontSize:16
                                    }}
                                    placeholder={t("email")}
                                    value={values.email}
                                    onBlur={handleBlur}
                                    onChange={(e, event) => {
                                        handleChange({ ...event, target: { name: 'email', value: e.target.value } })
                                    }}
                                    error={!!touched.email && !!errors.email}

                                    />
                            </Box>



                            <Box

                                sx={{
                                    display:"flex",
                                    justifyContent:"flex-end",
                                    marginTop:2,
                                    width:1,

                                }}
                            >
                                <Shbutton type="submit" disabled={!isOnline} block color={isOnline ? theme.palette.mode === "dark" ? "blue" : "primary" : "red"} variant="contained"
                                    sx={isOnline && brand?.color?.button ? {
                                        backgroundColor: `${theme.palette.mode === "dark" ? brand.color.button.dark : brand.color.button.light} !important`,
                                        color: `${theme.palette.mode === "dark" ? brand.color.button.contrastDark : brand.color.button.contrastLight} !important`,
                                        "&:hover": { backgroundColor: `${theme.palette.mode === "dark" ? brand.color.button.dark : brand.color.button.light} !important` },
                                    } : {}}
                                >
                                    {t("request_password_reset")}
                                </Shbutton>
                                {/* <Button type="submit" color="primary" variant="contained">
                                    Create new user
                                </Button> */}
                            </Box>
                            <Box

                                sx={{
                                    display:"flex",
                                    justifyContent:"flex-end",
                                    marginTop:2,
                                    width:1,

                                }}
                            >
                                <Shbutton link={brandSlug ? `/login/${brandSlug}` : "/login"} disabled={!isOnline} block color={theme.palette.mode === "dark" ? "primaryGreyOpposite" : "primaryGrey"} variant="text">
                                    {t("back_to_login")}
                                </Shbutton>
                            </Box>
                        </form>
                    )}
                </Formik>
                :
                    <React.Fragment>
                        <Box
                                sx={{
                                    display:"flex",
                                    justifyContent:"flex-end",
                                    width:1,

                                }}
                        >
                                <Shbutton link={brandSlug ? `/login/${brandSlug}` : "/login"} disabled={!isOnline} block color={theme.palette.mode === "dark" ? "primaryGreyOpposite" : "primaryGrey"} variant="contained">
                                {t("back_to_login")}
                            </Shbutton>
                            {/* <Button type="submit" color="primary" variant="contained">
                                Create new user
                            </Button> */}
                        </Box>

                    </React.Fragment>
                }
            </Box>
        </Box>
    )
}

export default Forgotpassword;
